'use client';

import { Carousel, CarouselSlide } from '@mantine/carousel';
import { Box, Group, Image } from '@mantine/core';
import type { ProductGet } from '@website/types';
import { constructImageUrl } from '@website/utils/helpers';
import type { EmblaCarouselType } from 'embla-carousel';
import { useEffect, useState } from 'react';
import cls from './styles.module.css';

export function ProductCarousel({
  product,
}: {
  product: NonNullable<ProductGet>;
}) {
  const [embla, setEmbla] = useState<EmblaCarouselType | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (embla) {
      embla.on('select', () => {
        setActiveIndex(embla.selectedScrollSnap());
      });
    }
  }, [embla]);

  return (
    <Box>
      <Carousel
        withControls
        withIndicators
        getEmblaApi={setEmbla}
        emblaOptions={{ loop: true }}
        classNames={{ root: cls.carousel }}
      >
        {product.assets.map((asset) => (
          <CarouselSlide key={asset.id}>
            <Image
              h="100%"
              alt={product.title}
              src={constructImageUrl(asset.file.key)}
            />
          </CarouselSlide>
        ))}
      </Carousel>

      <Group justify="center" mt="md" visibleFrom="sm">
        {product.assets.map((asset, index) => (
          <Box
            key={asset.id}
            className={cls.thumbnail}
            data-active={activeIndex === index}
            onClick={() => embla?.scrollTo(index)}
          >
            <Image
              radius="sm"
              alt={`Thumbnail ${index + 1}`}
              src={constructImageUrl(asset.file.key)}
            />
          </Box>
        ))}
      </Group>
    </Box>
  );
}
